<template>
  <div class="flex flex-col items-center justify-center h-full">
    <img src="/img/connections/icons/success.png" alt="Checkmark" />
    <h3 class="text-center m-4">Sign up success!</h3>
    <p class="lg:w-1/2 text-center mb-6">
      An email has been sent to you to verify your sign up. Please head to your
      emails and click the 'Verify Details' button to complete your sign up.
    </p>

    <p class="text-center text-truegray-500">
      Thank you for supporting {{ settings.profile_title }}
    </p>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from '../../../../../js/store/index.js'

export default defineComponent({
  name: 'ModalAddConnectionSuccess',

  setup() {
    const store = useStore()
    const settings = computed(() => store.getters['shared/getSettings'])

    return {
      settings,
    }
  },
})
</script>
